import { render, staticRenderFns } from "./deliverList.vue?vue&type=template&id=96cc2300&scoped=true"
import script from "./deliverList.vue?vue&type=script&lang=js"
export * from "./deliverList.vue?vue&type=script&lang=js"
import style0 from "./deliverList.vue?vue&type=style&index=0&id=96cc2300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cc2300",
  null
  
)

export default component.exports